import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import Text from "../Text";

const Base = styled.div`
  display: flex;
  justify-content: center;
`;

const StepperInner = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  &:before {
    position: absolute;
    left: 1px;
    right: 1px;
    top: 50%;
    transform: translateY(-50%);
    height: 2px;
    background-color: ${select.color(["grey", 1])};
    content: "";
    z-index: -1;
  }
`;

type StepProps = {
  active: boolean;
};

const Step = styled.div<StepProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: ${select.color(["grey", 7])};
  background-color: ${select.color(["grey", 1])};
  transition: ${select.speed("normal")};

  ${p =>
    p.active &&
    css`
      background-color: ${select.color(["primary", 6])};
      color: #fff;
    `};

  &:not(:last-child) {
    margin-right: ${select.space(4)};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  steps: number;
  currentStep: number;
  onClick?: (step: number) => void;
};

function Stepper(
  { style, className, steps, currentStep, onClick }: Props,
  ref: any
) {
  return (
    <Base ref={ref} style={style} className={className}>
      <StepperInner>
        {new Array(steps).fill(true).map((_, index) => {
          const step = index + 1;
          return (
            <Step
              active={step === currentStep}
              key={step}
              onClick={() => onClick && onClick(step)}
            >
              <Text fs={0} c="inherit">
                {step}
              </Text>
            </Step>
          );
        })}
      </StepperInner>
    </Base>
  );
}

export default React.forwardRef(Stepper);
